import React from 'react';

interface CompositeFieldContextValue {
  isInCompositeField: boolean;
}

export const CompositeFieldContext =
  React.createContext<CompositeFieldContextValue | null>(null);
